import firebase from 'firebase'
// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyA_D0GLdzZdakSg2C16rZHfLTnTqQk1SlA",
    authDomain: "dortleme.firebaseapp.com",
    databaseURL: "https://dortleme.firebaseio.com",
    projectId: "dortleme",
    storageBucket: "dortleme.appspot.com",
    messagingSenderId: "934456220946",
    appId: "1:934456220946:web:39eabde9f85c26c075e7cb",
    measurementId: "G-2CFHX6V7B6"
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
firebase.analytics();

export default firebaseApp.firestore()